module.exports = __webpack_public_path__ + "img/para-amanha-icon.bda97d9f.png";